/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Tier_Student_DescInputs */

const en_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI actions per month, unlimited resumes, interview prep, salary data, PDF and DOCX export. Requires university email verification.`)
};

const de_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 KI-Aktionen pro Monat, unbegrenzte Lebenslaeufe, Vorstellungsgespraechsvorbereitung, Gehaltsdaten, PDF- und DOCX-Export. Erfordert Verifizierung der Universitaets-E-Mail.`)
};

const fr_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 actions IA par mois, CV illimités, préparation d'entretien, données salariales, export PDF et DOCX. Nécessite la vérification d'un e-mail universitaire.`)
};

const es_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 acciones IA al mes, currículos ilimitados, preparación de entrevista, datos salariales, exportación PDF y DOCX. Requiere verificación de correo universitario.`)
};

const it_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 azioni AI al mese, curriculum illimitati, preparazione colloqui, dati salariali, esportazione PDF e DOCX. Richiede la verifica dell'email universitaria.`)
};

const nl_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI-acties per maand, onbeperkte cv's, sollicitatiegespreksvoorbereiding, salarisgegevens, PDF- en DOCX-export. Universiteits-e-mailverificatie vereist.`)
};

const pl_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 akcji AI miesięcznie, nieograniczona liczba CV, przygotowanie do rozmowy kwalifikacyjnej, dane o wynagrodzeniach, eksport PDF i DOCX. Wymaga weryfikacji uczelnianego adresu e-mail.`)
};

const fi_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI-toimintoa kuukaudessa, rajaton määrä ansioluetteloita, haastatteluvalmistelu, palkkatiedot, PDF- ja DOCX-vienti. Edellyttää yliopiston sähköpostiosoitteen vahvistamista.`)
};

const da_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI-handlinger per måned, ubegrænsede CV'er, interviewforberedelse, løndata, PDF- og DOCX-eksport. Kræver universitets-e-mailbekræftelse.`)
};

const sv_agb_tier_student_desc = /** @type {(inputs: Agb_Tier_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75 AI-åtgärder per månad, obegränsat antal CV:n, intervjuförberedelse, lönedata, PDF- och DOCX-export. Kräver verifiering av universitetsmejl.`)
};

/**
* | output |
* | --- |
* | "75 AI actions per month, unlimited resumes, interview prep, salary data, PDF and DOCX export. Requires university email verification." |
*
* @param {Agb_Tier_Student_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_tier_student_desc = /** @type {((inputs?: Agb_Tier_Student_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Tier_Student_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_tier_student_desc(inputs)
	if (locale === "fr") return fr_agb_tier_student_desc(inputs)
	if (locale === "es") return es_agb_tier_student_desc(inputs)
	if (locale === "it") return it_agb_tier_student_desc(inputs)
	if (locale === "nl") return nl_agb_tier_student_desc(inputs)
	if (locale === "pl") return pl_agb_tier_student_desc(inputs)
	if (locale === "fi") return fi_agb_tier_student_desc(inputs)
	if (locale === "da") return da_agb_tier_student_desc(inputs)
	if (locale === "sv") return sv_agb_tier_student_desc(inputs)
	return en_agb_tier_student_desc(inputs)
});